/**
 * Shared UI icons (emojis) used throughout the application
 * Centralizing these ensures consistency and makes it easier to change icons globally.
 */
export const UI_ICONS = {
	// General actions
	SAVE: "💾",
	CANCEL: "❌",
	DELETE: "🗑️",
	EDIT: "✏️",
	ADD: "➕",
	EXPORT: "📤",
	IMPORT: "📥",
	BACK: "←",
	COPY: "📋",
	FAVORITE_ACTIVE: "★",
	FAVORITE_INACTIVE: "☆",
	HISTORY: "📜",
	SEARCH: "🔍",

	// Media/Playback
	PLAY: "▶",
	PAUSE: "⏸",
	SKIP_BACK: "⏪",
	SKIP_FORWARD: "⏩",
	REGENERATE: "✨",
	PASSWORD_VISIBLE: "👁️",
	PASSWORD_HIDDEN: "🙈",
	WARNING: "⚠️",
	INFO: "ℹ️",
	CLOSE: "×",

	// Domain objects
	PRESET: "🗂️",
	SUMMARY: "📄",
	TRANSCRIPT: "📝",
	COMMENT: "💬",
	SETTINGS: "⚙️",
	DATE: "📅",
	DURATION: "⏱️",
} as const;
